import { render, staticRenderFns } from "./SalePage20230001.vue?vue&type=template&id=60e3da16&scoped=true"
import script from "./SalePage20230001.vue?vue&type=script&lang=js"
export * from "./SalePage20230001.vue?vue&type=script&lang=js"
import style0 from "./SalePage20230001.vue?vue&type=style&index=0&id=60e3da16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3da16",
  null
  
)

export default component.exports